import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-plus2",
  "use": "icon-plus2-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-plus2\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><g fill=\"currentColor\"><path d=\"M2 7.5h12V9H2z\" /><path d=\"M8.75 2.25v12h-1.5v-12z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol